import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPipe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPipe"><Path d="M9 19.5H10.5V11.5H19V19.5H21V21H3V19.5H5V11.5H9V19.5Z" fill="currentColor"/><Path d="M7 10H3V3H7V10Z" fill="currentColor"/><Path d="M21 10H8.5V3H21V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPipe;
